import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { beautifyCoachReply } from '../../playing/beautifyCoachReply';

/**
 * Renders a coach reply as readable chat HTML.
 * While typing: plain text + caret. When done: polished markdown.
 */
export default function CoachMarkdown({ content, typing = false }) {
  const markdown = useMemo(
    () => beautifyCoachReply(content),
    [content],
  );

  if (typing) {
    return (
      <div className="playing-coach-md playing-coach-md--typing">
        {content}
        <span className="playing-coach-caret" aria-hidden />
      </div>
    );
  }

  return (
    <div className="playing-coach-md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <p className="playing-coach-md__heading">{children}</p>,
          h2: ({ children }) => <p className="playing-coach-md__heading">{children}</p>,
          h3: ({ children }) => <p className="playing-coach-md__heading">{children}</p>,
          h4: ({ children }) => <p className="playing-coach-md__heading">{children}</p>,
          p: ({ children }) => <p className="playing-coach-md__p">{children}</p>,
          strong: ({ children }) => <strong className="playing-coach-md__strong">{children}</strong>,
          em: ({ children }) => <em className="playing-coach-md__em">{children}</em>,
          ul: ({ children }) => <ul className="playing-coach-md__ul">{children}</ul>,
          ol: ({ children }) => <ol className="playing-coach-md__ol">{children}</ol>,
          li: ({ children }) => <li className="playing-coach-md__li">{children}</li>,
          blockquote: ({ children }) => (
            <blockquote className="playing-coach-md__quote">{children}</blockquote>
          ),
          pre: ({ children }) => <pre className="playing-coach-md__pre">{children}</pre>,
          code: ({ className, children }) => {
            if (!className) {
              return <code className="playing-coach-md__code-inline">{children}</code>;
            }
            return <code className={className}>{children}</code>;
          },
          a: ({ href, children }) => (
            <a className="playing-coach-md__a" href={href} target="_blank" rel="noreferrer">
              {children}
            </a>
          ),
          table: ({ children }) => (
            <div className="playing-coach-md__table-wrap">
              <table className="playing-coach-md__table">{children}</table>
            </div>
          ),
          hr: () => <hr className="playing-coach-md__hr" />,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
